























import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';

@Component
export default class DropDown extends Vue {
  private selected: object = [];

  @Prop() private options: any[] | undefined;
  @Prop({default: 'Please select...'}) private placeHolder: string | undefined;
  @Prop({default: ''}) private name: string | undefined;
  @Prop({default: ''}) private newRow: string | undefined;
  @Prop({default: false}) private disabled: boolean | undefined;
  @Prop({default: false}) private clearable: boolean | undefined;

  @Watch('options', {immediate: true})
  public onReceiveOptions() {
    this.options ? this.selected = this.options.find((option: any) => option.active === true) : this.selected = {};
  }

  private emitChange(e: any) {
    const event: any = {};
    event.target = {};
    event.target.value = e;
    this.$emit('onchange', event.target);
  }

}
